import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { sequenceProjectApi } from '../api/sequenceProjectApi'

interface IEmployeesState {
  sequenceProject: string[]
}

const initialState: IEmployeesState = {
  sequenceProject: []
}

export const sequenceProjectSlice = createSlice({
  name: 'sequenceProject',
  initialState,
  reducers: {
    // setEmployees(state, {payload}: PayloadAction<IEmployee[]>) {
    //   state.employees = payload
    // }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      sequenceProjectApi.endpoints?.getSequenceProject.matchFulfilled,
      (state, { payload }: PayloadAction<string[]>) => {
        state.sequenceProject = payload
      }
    )
  }
})

export const sequenceProjectActions = sequenceProjectSlice.actions
export const sequenceProjectReducer = sequenceProjectSlice.reducer
